import { useI18n } from "../i18n";
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { PayDialog } from "./PayDialog";

const GROUPS = [
  { title: "Mensile", ids: ["monthly"], featured: true },
];

const PlanOption = ({ p, onPick, t }) => (
  <button className="plan-option" onClick={() => onPick(p)} data-testid={`plan-${p.id}-btn`}>
    <span className="font-heading text-xl">{t("subscribeBtn")}</span>
    <span className="font-mono text-xs text-muted">{t("subscribeNote")}</span>
  </button>
);

export const PlansSection = () => {
  const { t } = useI18n();
  const [plans, setPlans] = useState([]);
  const [picked, setPicked] = useState(null);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);
  const byId = Object.fromEntries(plans.map((p) => [p.id, p]));
  if (!plans.length) return null;

  return (
    <section className="grid gap-6" data-testid="plans-section">
      <div>
        <p className="label">{t("plans")}</p>
        <h2 className="font-heading text-base md:text-lg mt-2">{t("plansSub")}</h2>
      </div>
      <div className="grid max-w-md gap-4">
        {GROUPS.map((g) => {
          const first = byId[g.ids[0]];
          return (
            <div key={g.title} className={`panel p-6 flex flex-col gap-4 pkg ${g.featured ? "pkg-featured" : ""}`} data-testid={`plan-group-${g.ids[0]}`}>
              <div className="flex items-center justify-between">
                <span className="label text-primary">{t("monthly")}</span>
                {g.badge && <span className="label text-amber flex items-center gap-1"><Sparkles size={11} />{g.badge}</span>}
              </div>
              <p className="font-mono font-black text-5xl text-amber glow-amber">{first.credits}</p>
              <p className="label">{t("creditsMonth")}</p>
              <p className="font-heading text-2xl">{first.per_month}€<span className="text-sm text-muted"> {t("perMonth")}</span></p>
              <div className="grid gap-2 mt-auto">{g.ids.map((id) => byId[id] && <PlanOption key={id} p={byId[id]} onPick={setPicked} t={t} />)}</div>
            </div>
          );
        })}
      </div>
      {picked && <PayDialog plan={picked} onClose={() => setPicked(null)} />}
    </section>
  );
};
